// export const AppTitle = 'Iconic Classified ';
export const AppTitle = 'UNK Sagacious ';
export const AdFetchLimit = 20;
export const TEST_MODE = false;
export const signOffPendingSeafarerList = [];
